import { Component, OnInit, Output, EventEmitter } from '@angular/core';


import { NavigationStart, Router, Event as NavigationEvent, NavigationEnd, ActivatedRoute  } from '@angular/router';

import { Observable } from 'rxjs';
import { AngularFireStorage, AngularFireStorageReference } from '@angular/fire/storage';
import { AngularFirestore } from '@angular/fire/firestore';

import { Blobs, BlobService, UrlService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-storage-input',
  templateUrl: './storage-input.component.html',
  styleUrls: ['./storage-input.component.scss']
})
export class StorageInputComponent implements OnInit {
  @Output() filed = new EventEmitter<File>();
  param: string;
  blobs: Blobs;
  // storage = firebase.storage();
  file: File;
  name: string;
  ref: AngularFireStorageReference;
  url: string;
  bytesTransferred: number;
  uploadPercent: Observable<number>;
  constructor(
    private db:AngularFirestore,
    private storage: AngularFireStorage,
    private route: ActivatedRoute,
    private urlservice: UrlService,
    private router: Router,
    private blobsservice: BlobService) {
      this.urlservice.url$.subscribe(u => {
        this.url = u;
        console.log(u);
      });
     }
  uploadFile(event) {
this.file = event.target.files[0];
this.name = this.file.name;
this.ref = this.storage.ref(`${this.url + '/' + this.name}`);
this.filed.emit(this.file);
  }
  storedBlob() {
// Start the upload
const task = this.storage.upload(`${this.url + '/' + this.name}`, this.file);
this.uploadPercent = task.percentageChanges();
task.then(m => {
  const meta = this.ref.getMetadata();
  const downloadURL = this.ref.getDownloadURL();
  downloadURL.subscribe(url => {
    meta.subscribe( m => {
      this.blobs = {bucket: m.bucket,
            fullPath : m.fullPath,
            id: this.name,
            refFirestore:this.db.collection('blobs').doc<Blobs>(this.name).ref,
            
            name : m.name,
            size : m.size,
            downloadURL: url,
            updated : new Date( m.updated),
            timeCreated : new Date( m.timeCreated),
            contentType : m.contentType};
      this.blobsservice.update(this.blobs);
    });
  });

});

}


  ngOnInit() {
this.param = this.route.snapshot.params.id;
  }

}
